import { Component, Input, Signal } from '@angular/core'
import { BookingHubComponent } from './components/booking-hub/booking-hub.component'
import { CommonModule } from '@angular/common'
import {
    ConfirmedSessionsService,
    FeatureCheckService,
    MeetingsService,
    SelectedSession,
    SelectedSessionService,
    UtilsService,
} from '@app/core/_services'
import { filter, Subject, take, takeUntil } from 'rxjs'
import { SelectedSessionsListComponent } from './components/selected-sessions-list/selected-sessions-list.component'
import { ScrollPanelModule } from 'primeng/scrollpanel'
import { UpcomingSessionPanelComponent } from './components/upcoming-session-panel/upcoming-session-panel.component'
import { WelcomeChecklistService } from '@app/core/_services/welcome-checklist.service'
import { WelcomeChecklistSidebarComponent } from '@app/new-welcome-checklist/welcome-checklist-sidebar/welcome-checklist-sidebar.component'
import { YearInFocusSidebarComponent } from '@app/shared-dialogs/year-in-review/year-in-focus-sidebar.component'
import {
    MeetingsBookingsMeetingItem,
    ConfirmedSessionsResponse,
    Container,
    User,
} from '@app/core/_models'
import { UserService } from '@app/core/_services/user.service'
import { GroupFilterComponent } from './components/group-filter/group-filter.component'
import { ViewportService } from '@app/core/_services/viewport.service'
import { UpcomingSessionsService } from './services/upcoming-sessions.service'
import { GroupMeetingsSidebarComponent } from './components/group-meetings-sidebar/group-meetings-sidebar.component'

@Component({
    selector: 'fm-left-panel',
    imports: [
        GroupFilterComponent,
        UpcomingSessionPanelComponent,
        SelectedSessionsListComponent,
        BookingHubComponent,
        CommonModule,
        ScrollPanelModule,
        WelcomeChecklistSidebarComponent,
        GroupMeetingsSidebarComponent,
        YearInFocusSidebarComponent,
    ],
    templateUrl: './left-panel.component.html',
    styleUrl: './left-panel.component.scss',
})
export class LeftPanelComponent {
    @Input() hideBookingHubOnMobile = false
    private ngUnsubscribe: Subject<any> = new Subject<any>()

    public enableScrollbar: boolean = false
    public selectedSessions: SelectedSession[] = []
    public showUpcomingSessions: boolean = false

    isWelcomeChecklistActive: Signal<boolean> =
        this.welcomeChecklistService.isWelcomeChecklistActive
    isGroupMeetingsBetaEnabled: Signal<boolean> =
        this.featureCheckService.groupMeetingsBetaEnabledSig

    constructor(
        public viewportService: ViewportService,
        public userService: UserService,
        private selectedSessionService: SelectedSessionService,
        private welcomeChecklistService: WelcomeChecklistService,
        private meetingsService: MeetingsService,
        private confirmedSessionsService: ConfirmedSessionsService,
        private featureCheckService: FeatureCheckService,
        private upcomingSessionsService: UpcomingSessionsService,
        private utilsService: UtilsService,
    ) {}

    ngOnInit(): void {
        this.selectedSessionService.selectedSessions$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((selectedSessions: SelectedSession[]) => {
                this.selectedSessions = [...selectedSessions]
            })

        this.meetingsService.meetingsBookingsSubject
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe((eventsBookingsState) => {
                this.showUpcomingSessions = this.hasUpcomingBooking(eventsBookingsState.meetings)
            })
    }

    ngAfterViewInit() {}

    ngOnDestroy() {
        this.ngUnsubscribe.next(null)
        this.ngUnsubscribe.complete()
    }

    private hasUpcomingBooking(meetings: MeetingsBookingsMeetingItem[]): boolean {
        const currentTime = this.utilsService.getCurrentTimestamp()
        for (const meeting of meetings) {
            if (
                this.utilsService.hasSessionEnded(meeting.startMs, meeting.durationMs, currentTime)
            ) {
                continue
            }
            if (meeting.meetingType === 'group_meeting') {
                return true
            }
            if (
                this.utilsService.shouldDisplaySession(
                    meeting.sessionType ?? 'standard',
                    meeting.startMs,
                    meeting.state ?? 0,
                    !!meeting.partnerId,
                )
            ) {
                return true
            }
        }
        return false
    }
}
